import { content } from "@/i18n/content";
import { useLang } from "@/i18n/language";
import { Section, SectionHeading } from "./Primitives";

export function About() {
  const { lang } = useLang();
  const t = content[lang];

  return (
    <Section id="about" tone="light">
      <div className="grid gap-12 md:grid-cols-[0.9fr_1.1fr]">
        <div>
          <p className="eyebrow text-primary">{t.about.eyebrow}</p>
          <h2 className="mt-3 text-3xl leading-[1.1] font-semibold tracking-tight text-balance-tight md:text-4xl">
            {t.about.title}
          </h2>
        </div>
        <div className="space-y-5 text-base leading-relaxed text-cream-foreground/80">
          {t.about.body.map((p) => (
            <p key={p.slice(0, 24)}>{p}</p>
          ))}
        </div>
      </div>

      <div className="mt-20 border-t border-cream-foreground/10 pt-14">
        <SectionHeading eyebrow={t.values.eyebrow} title={t.values.title} tone="light" />
        <div className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
          {t.values.items.map((v, i) => (
            <div key={v.title} className="border-t border-cream-foreground/15 pt-5">
              <span className="text-xs font-semibold tracking-widest text-primary">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-2 text-lg font-semibold">{v.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream-foreground/70">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
